
<script>
import GroupOneRaceHeader from './GroupOneRaceHeader';
import GroupOneRaceSelection from './GroupOneRaceSelection';
import ViewportWidth from '../../mixins/ViewportWidth';
import { mapGetters } from 'vuex';
export default {
  name: 'GroupOneRaceTips',
  components: {
    GroupOneRaceHeader,
    GroupOneRaceSelection,
  },
  mixins: [ViewportWidth],
  props: {
    eventId: {
      type: [Number, String],
      default: () => 0,
    },
    bookmaker: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      readMoreActive: false,
    };
  },
  computed: {
    ...mapGetters({
      eventData: 'GroupOneRaceTips/getEventOdds',
      eventAnalysis: 'GroupOneRaceTips/getEventAnalysis',
      eventSelections: 'GroupOneRaceTips/getEventSelections',
    }),
    moreText() {
      return this.readMoreActive ? 'Read Less' : 'Read More';
    },
    isMobile() {
      return this.viewportWidth < 677;
    },
    orderedTipSelections() {
      const { eventSelections } = this;
      return eventSelections.length > 0 ? eventSelections.sort((a, b) => a.tipOrder - b.tipOrder) : [];
    },
  },
  mounted() {
    const { eventId, bookmaker } = this;
    this.$store.dispatch('GroupOneRaceTips/fetchRacingCalendarEvent', { eventId, bookmaker });
  },
  methods: {
    toggleReadMore() {
      this.readMoreActive = !this.readMoreActive;
    },
  },
};
</script>


<template>
  <div class="group-one-race-tips">
    <!-- Meeting info -->
    <div class="group-one-race-tips__meeting-container">
      <GroupOneRaceHeader />
    </div>
    <!-- Meeting tips and analysis -->
    <div class="group-one-race-tips__meeting-tips-container">
      <div class="group-one-race-tips__meeting-tips-left">
        <h3 class="group-one-race-tips__meeting-tips-header">Analysis</h3>
        <div
          :class="{ 'hidden': !readMoreActive && isMobile }"
          class="group-one-race-tips__meeting-tips-details"
        >
          <p v-html="eventAnalysis"></p>
        </div>
        <a
          v-if="eventAnalysis"
          class="group-one-race-tips__read-more"
          href="#"
          @click.prevent="toggleReadMore"
        >{{ moreText }}</a>
      </div>
      <div class="group-one-race-tips__meeting-tips-right">
        <h3 class="group-one-race-tips__meeting-tips-header">Punters Selections</h3>
        <div class="group-one-race-tips__meeting-tips-details">
          <template v-for="(selection, index) in orderedTipSelections">
            <GroupOneRaceSelection
              :selection="selection"
              :key="`group-one-selection-${index}`"
              :is-mobile="isMobile"
              :bookmaker="bookmaker"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
